

export default class EventClusterRemoveDTO {

  public clusterId?: number;
  public updatedBy?: string;
  public isFull?: boolean;
  public doNotSendEmail?: boolean;


  // constructor(type: EventTypeDTO, date: string, stage: string, timezone: string, link: string, description: string, eventLanguage: string, id?: number) {
  //   this.type = type;
  //   this.date = date;
  //   this.stage = stage;
  //   this.timezone = timezone;
  //   this.link = link;
  //   this.description = description;
  //   this.eventLanguage = eventLanguage;
  // }

}
